import { render, staticRenderFns } from "./ModalFinishedOrder.vue?vue&type=template&id=146dc84c&scoped=true&"
import script from "./ModalFinishedOrder.vue?vue&type=script&lang=js&"
export * from "./ModalFinishedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146dc84c",
  null
  
)

export default component.exports